import { DischargeContractsInterface } from '~/models/interfaces/services/Contracts'

const initialState: DischargeContractsInterface = {
  contracts: [],
}

export default initialState
